// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.accordion-budget-requests-table__table {
  width: 100%;
  background-color: white;
  margin: 32px 0;
  border-radius: 4px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.16);
}
.accordion-budget-requests-table__table__extra-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  padding: 12px 16px;
  min-height: 45px;
}
.accordion-budget-requests-table__table__extra-header__title .pui-headline {
  font-weight: bold;
  color: #4a4a4a;
  margin: 0;
}
.accordion-budget-requests-table__table__extra-header__toggle .pui-toggle {
  margin: 0;
}
.accordion-budget-requests-table__table__extra-header__actions {
  display: flex;
  gap: 10px;
}
.select-input {
  min-height: 40px;
  margin-top: 20px;
  margin-bottom: 20px;
}
@media (min-width: 768px) {
.select-input {
    margin-top: 50px;
    margin-bottom: 0;
}
}
.accordion-budget {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin-bottom: 50px;
}
.accordion-budget .dropright:hover > .dropdown-menu {
  display: block;
}
.accordion-budget .section-checked ~ .header-table-wrapper {
  position: sticky;
  top: 195px;
  z-index: 1;
}
@media (max-width: 768px) {
.accordion-budget .section-checked ~ .header-table-wrapper {
    top: 205px;
}
}
.accordion-budget .table-scroll::-webkit-scrollbar {
  display: none;
}
.accordion-budget .table-scroll {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.accordion-budget .header-table-scroll-sync::-webkit-scrollbar {
  display: none;
}
.accordion-budget .header-table-scroll-sync {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.accordion-budget .scroll-bottom-bar {
  overflow-x: scroll;
  overflow-y: hidden;
  position: sticky;
  bottom: 0;
  display: flex;
  white-space: nowrap;
}
.accordion-budget .local-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .wbs-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .country-wrapper {
  min-width: 8rem;
  max-width: 8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .plant-group-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .plant-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .unit-wrapper {
  min-width: 25.6rem;
  max-width: 25.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .project-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .lump-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .aero-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .justification-wrapper {
  min-width: 33.6rem;
  max-width: 33.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .maintenance-wrapper {
  min-width: 22.4rem;
  max-width: 22.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .outageid-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .risk-wrapper {
  min-width: 18.4rem;
  max-width: 18.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .procurement-wrapper {
  min-width: 27.2rem;
  max-width: 27.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .comment-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .planning-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .budget-wrapper {
  min-width: 18.4rem;
  max-width: 18.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .startdate-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .enddate-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .currency-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .spenduntil-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .previous-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .previousplusone-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .previousplustwo-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .previoustotal-wrapper {
  min-width: 16rem;
  max-width: 16rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .forecast-wrapper {
  min-width: 16.8rem;
  max-width: 16.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .newmtpplus1-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .newmtpplus2-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .newmtpplus3-wrapper {
  min-width: 13.6rem;
  max-width: 13.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .uel-wrapper {
  min-width: 19.2rem;
  max-width: 19.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .after-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .total-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .cr-wrapper {
  min-width: 10.4rem;
  max-width: 10.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .fundingstatus-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .primary-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .mainflag-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .otherflag-wrapper {
  min-width: 24rem;
  max-width: 24rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .review-wrapper {
  min-width: 30.4rem;
  max-width: 30.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .priocategory-wrapper {
  min-width: 24rem;
  max-width: 20.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .priorank-wrapper {
  min-width: 24rem;
  max-width: 20.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .created-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .createdby-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .modified-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .modifiedby-wrapper {
  min-width: 17.6rem;
  max-width: 17.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .outagetype-wrapper {
  min-width: 11.2rem;
  max-width: 11.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .header-table {
  display: flex;
  height: 48px;
  background-color: white;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}
.accordion-budget .header-table.fixed-scrool-bottom {
  height: 0;
  border: none;
}
.accordion-budget .header-table .fixed-globalid {
  position: sticky;
  left: 0;
  min-width: 22.464rem;
  max-width: 22.464rem;
  background-color: white;
  border-right: none;
  padding-left: 25px;
}
.accordion-budget .header-table .fixed-globalid .checkmark {
  top: 13px;
}
.accordion-budget .header-table .fixed-name {
  position: sticky;
  left: 22.464rem;
  min-width: 41.6rem;
  max-width: 41.6rem;
  background-color: white;
  border-left: 1px solid #d4d4d4;
  border-right: 1px solid #d4d4d4;
  box-shadow: 2px 0px 3px rgba(0, 0, 0, 0.1);
}
@media (max-width: 991px) {
.accordion-budget .header-table .fixed-globalid {
    position: relative;
    left: 0;
    min-width: 20.8rem;
    max-width: 20.8rem;
    background-color: white;
    border-right: none;
    padding-left: 25px;
}
.accordion-budget .header-table .fixed-globalid .checkmark {
    top: 13px;
}
.accordion-budget .header-table .fixed-name {
    position: relative;
    left: 0;
    min-width: 22.48rem;
    background-color: white;
    border-left: 1px solid #d4d4d4;
    border-right: 1px solid #d4d4d4;
    box-shadow: none;
}
}
@media (max-width: 767px) {
.accordion-budget .header-table .fixed-name {
    min-width: 19.28rem;
}
}
.accordion-budget .header-table div {
  padding: 10px;
  border-right: 1px solid #d4d4d4;
}
.accordion-budget .header-table-wrapper {
  position: sticky;
  top: 90px;
  z-index: 2;
}
.accordion-budget .icon-warning {
  position: absolute;
  margin-top: 4px;
  padding-left: 4px;
}
.accordion-budget .icon-dropdown {
  position: absolute;
  margin-top: 4px;
}
.accordion-budget .box {
  width: 14px;
  height: 14px;
  display: inline-block;
  top: 1px;
  border-radius: 15px;
  margin-right: 10px;
  position: relative;
}
.accordion-budget .fix .dropright .dropdown-toggle::after {
  vertical-align: 0;
  margin-left: 10px;
}
.accordion-budget table .fix button span {
  padding-left: 25px;
}
.accordion-budget .fix .dropdown-item:disabled {
  opacity: 50%;
}
.accordion-budget .showingBR {
  display: inline-block;
  padding-left: 10px;
}
.accordion-budget table tr > td:nth-child(1) {
  text-align: start;
}
.accordion-budget table .dropdown-item button span {
  margin-left: 10px;
}
.accordion-budget .multiselect {
  min-width: 150px;
}
.accordion-budget .itemsChecked {
  background-color: #bad8f1 !important;
}
.accordion-budget .itemsChecked td {
  background-color: #bad8f1 !important;
}
.accordion-budget #dropdownMenuLink {
  position: absolute;
}
.accordion-budget label.container {
  max-width: 0;
}
.accordion-budget {
  /* Hide the browser's default checkbox */
}
.accordion-budget #readyForApproval input {
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
}
.accordion-budget #readyForApproval span {
  margin-top: 10px;
  color: #007bff;
  background-color: transparent;
  border: 1px solid #ADADAD;
  margin-right: 5px;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  padding: 0.6rem 1.2rem;
  font-size: 1.6rem;
  line-height: 1.5;
  border-radius: 0.4rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.accordion-budget #readyForApproval label {
  margin-bottom: 0;
  cursor: pointer;
}
.accordion-budget #readyForApproval input:checked + span {
  background: #0062cc;
  color: #fff;
}
.accordion-budget {
  /* Hide the browser's default checkbox */
}
.accordion-budget .container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.accordion-budget {
  /* Create a custom checkbox */
}
.accordion-budget .checkmark {
  position: absolute;
  top: 15px;
  margin-left: -15px;
  height: 20px;
  width: 20px;
  border: 2px solid #d0d0d0;
  border-radius: 4px;
}
.accordion-budget {
  /* When the checkbox is checked, add a blue background */
}
.accordion-budget .container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 2px solid #2196F3;
}
.accordion-budget {
  /* Create the checkmark/indicator (hidden when not checked) */
}
.accordion-budget .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.accordion-budget {
  /* Show the checkmark when checked */
}
.accordion-budget .container input:checked ~ .checkmark:after {
  display: block;
}
.accordion-budget {
  /* Style the checkmark/indicator */
}
.accordion-budget .container .checkmark:after {
  left: 6px;
  top: 0px;
  width: 5px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.accordion-budget .btn {
  background-color: transparent;
}
.accordion-budget .fix input {
  margin-right: 10px;
  margin-left: 5px;
}
.accordion-budget .fix:nth-child(1) {
  left: 15px;
  position: absolute;
  width: 22.4rem;
  border-right: 0;
  border-left: 1px solid #d4d4d4;
  padding-left: 25px;
}
.accordion-budget .collapsing .fix:nth-child(1) {
  left: 0;
}
.accordion-budget .fix:nth-child(2) {
  left: 24rem;
  position: absolute;
  width: 41.6rem;
  border-left: 1px solid #d4d4d4;
  padding-right: 2px;
}
.accordion-budget .fix:nth-child(2) div {
  overflow: hidden;
  text-overflow: ellipsis;
}
.accordion-budget .collapsing .fix:nth-child(2) {
  left: 22.48rem;
}
.accordion-budget tr:nth-child(even) td {
  background-color: #f9f9f9;
}
.accordion-budget tr:last-child td {
  border-bottom: 1px solid #d4d4d4;
}
.accordion-budget table {
  width: 100%;
  margin-left: 64rem;
  overflow-y: visible;
  padding-bottom: 1px;
  display: block;
}
.accordion-budget button:focus {
  box-shadow: none;
}
.accordion-budget h5 button {
  width: 100%;
  text-align: left;
  font-size: 1.44rem;
}
.accordion-budget .table th {
  border-bottom: 1px solid #dee2e6;
}
.accordion-budget .table tr:first-child td:first-child {
  border-top: 1px solid transparent;
}
.accordion-budget .table tr:first-child td:nth-child(2) {
  border-top: 1px solid transparent;
}
.accordion-budget .active {
  color: #0078dc;
}
.accordion-budget .number {
  padding: 0 5px;
  font-weight: bold;
  cursor: pointer;
}
.accordion-budget .number ~ .third-number {
  padding-left: 0;
  padding-right: 5px;
}
.accordion-budget .arrow {
  cursor: pointer;
  position: relative;
  top: -0.5px;
}
.accordion-budget .table th,
.accordion-budget .table td {
  border-top: none;
  border-right: 1px solid #d4d4d4;
  white-space: nowrap;
  background-color: white;
}
.accordion-budget .table td .btn {
  font-weight: bold;
  padding: 0;
  right: 13px;
  top: 8px;
}
.accordion-budget .table {
  background-color: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
}
.accordion-budget .btn-clear {
  color: #007bff;
}
.accordion-budget .button-acc {
  background-color: #f3f5f7;
  padding: 37px 15px 18px;
  display: flex;
  flex-wrap: wrap;
}
.accordion-budget .button-acc .select {
  min-width: unset;
}
.accordion-budget .button-acc button {
  margin-top: 10px;
}
.accordion-budget .button-acc input {
  margin-top: 10px;
}
.accordion-budget .button-acc svg {
  position: absolute;
  right: 20px;
  margin-top: 12px;
  top: 5px;
  color: #ADADAD;
  transform: rotate(90deg);
  pointer-events: none;
}
.accordion-budget .button-acc svg.search-icon {
  pointer-events: all;
  cursor: pointer;
}
.accordion-budget .button-acc svg.icon-times {
  pointer-events: all;
  cursor: pointer;
  right: 45px;
  height: 1.2em;
  top: 3px;
}
.accordion-budget .button-acc .checkmark {
  top: unset;
  margin-top: -6px;
}
.accordion-budget .button-acc .section-button .btn {
  padding: 5px 15px;
  margin-top: 0;
}
.accordion-budget .button-acc .section-button .btn:nth-child(2) {
  position: absolute;
  right: 16px;
}
.accordion-budget .button-acc .section-button {
  padding: 5px 10px;
  background-color: #F3F5F7;
  border-bottom-left-radius: 0.4rem;
  border-bottom-right-radius: 0.4rem;
}
.accordion-budget .button-acc .dropdown-divider {
  margin: unset;
  margin-top: 8px;
}
.accordion-budget .button-acc .style-dropdown-filter {
  box-shadow: 2px 5px 9px 0px rgba(0, 0, 0, 0.2);
  padding-bottom: 0;
}
.accordion-budget .button-acc .active-filter.btn-primary {
  background-color: #0062cc;
  color: white;
}
.accordion-budget .button-acc .btn-filter {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
  white-space: nowrap;
}
.accordion-budget .section-checked {
  background-color: #0078dc;
  height: 105px;
  align-items: center;
  position: sticky;
  top: 90px;
  z-index: 2;
  padding-top: 10px;
  display: flex;
  flex-wrap: wrap;
}
.accordion-budget .section-checked .col a {
  margin-left: 25px;
}
@media (max-width: 768px) {
.accordion-budget .section-checked .col a {
    margin-left: 6px;
}
}
@media (max-width: 768px) {
.accordion-budget .section-checked {
    height: 135px;
}
}
.accordion-budget .section-checked .btn {
  color: #007bff;
}
.accordion-budget .section-checked .icon-cancel {
  padding-right: 5px;
  position: relative;
  font-size: 16px;
}
.accordion-budget .btn-primary {
  background-color: transparent;
  border: 1px solid #ADADAD;
  box-shadow: none !important;
  color: #007bff;
  margin-right: 5px;
}
.accordion-budget .select {
  background-color: #fff;
  border: 1px solid #ADADAD;
  box-shadow: none !important;
  color: #212529;
  padding-right: 65px;
  padding-left: 15px;
}
.accordion-budget .select::placeholder {
  color: #ADADAD;
}
.accordion-budget tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
.accordion-budget .warning-label {
  color: #fd7e14 !important;
}
@media (min-width: 991px) {
.accordion-budget tbody tr td:nth-child(2):after {
    content: " ";
    display: block;
    position: absolute;
    top: 0px;
    width: 3px;
    right: 1px;
    height: 48px;
    -moz-box-shadow: 0px 0px 3px #d1d571;
    box-shadow: 5px 0px 3px rgba(0, 0, 0, 0.1);
}
.accordion-budget thead tr th:nth-child(2) {
    border-top-right-radius: 6px;
    box-shadow: 2px 0px 4px rgba(0, 0, 0, 0.1);
}
}
.accordion-budget .Blue td:first-child {
  box-shadow: inset 12px 0px 0px -5px #607d8b;
}
.accordion-budget .Red td:first-child {
  box-shadow: inset 12px 0px 0px -5px #f50057;
}
.accordion-budget .Grey td:first-child {
  box-shadow: inset 12px 0 0px -5px #d6d6d6;
}
.accordion-budget .card-body {
  padding: 35px 15px;
  padding-bottom: 10px;
  padding-top: 0;
}
.accordion-budget .card-body:first-child {
  padding-bottom: 0;
}
.accordion-budget .search-form {
  float: right;
}
@media (min-width: 991px) {
.accordion-budget .fixed-name {
    border-top-right-radius: 6px;
}
}
@media (max-width: 991px) {
.accordion-budget table {
    margin-left: 0 !important;
    font-size: 1.44rem;
    padding-bottom: 0;
}
.accordion-budget table.table th {
    border-left: 1px solid #d4d4d4;
    border-right: none;
}
.accordion-budget table.table td {
    border-left: 1px solid #d4d4d4;
    border-right: none;
}
.accordion-budget table th.fix:nth-child(1) {
    display: table-cell;
    min-width: 19.2rem;
    max-width: 19.2rem;
    position: relative;
    left: 0;
    right: 0;
    padding-right: 23px;
    padding-left: 20px;
    border-bottom: none;
}
.accordion-budget table th.fix:nth-child(2) {
    display: table-cell;
    width: 22.4rem;
    position: relative;
    left: 0;
    right: 0;
}
.accordion-budget table td.fix:nth-child(1) {
    display: table-cell;
    min-width: 20.8rem;
    max-width: 20.8rem;
    position: relative;
    left: 0;
    right: 0;
    padding-right: 23px;
    padding-left: 20px;
    border-bottom: none;
}
.accordion-budget table td.fix:nth-child(2) {
    display: block;
    position: relative;
    left: 0;
    right: 0;
    width: 22.4rem;
    border-bottom: none;
    min-width: 150px;
}
.accordion-budget table td.fix:nth-child(2) div {
    width: 100%;
}
}
@media (max-width: 991px) and (max-width: 767px) {
.accordion-budget table td.fix:nth-child(2) {
    width: 19.2rem;
}
}
@media (max-width: 991px) {
.accordion-budget table.table td .btn {
    right: 10px;
    top: 5px;
}
.accordion-budget table tr:last-child td {
    border-bottom: none;
}
.accordion-budget .search-form {
    float: none;
}
.accordion-budget .search-form .input-group {
    width: 100%;
}
.accordion-budget .form-inline.nav-selectors {
    margin: 0 auto;
    width: 100%;
}
.accordion-budget .button-acc {
    padding-top: 15px;
}
.accordion-budget .button-acc .btn {
    margin-bottom: 5px;
}
.accordion-budget .icon-warning {
    padding-left: 6px;
}
}
@media (max-width: 767px) {
.accordion-budget .button-acc .btn-filter {
    width: 100%;
    max-width: none;
    font-size: 1.44rem;
}
.accordion-budget #readyForApproval label {
    width: 100%;
}
.accordion-budget #readyForApproval label span {
    width: 100%;
    font-size: 1.44rem;
}
}
@media (max-width: 575px) {
.accordion-budget .dropdown-menu.style-dropdown-filter {
    font-size: 12px;
    max-width: 180px;
}
.accordion-budget .dropdown-menu.style-dropdown-filter label {
    overflow: hidden;
    text-overflow: ellipsis;
}
.accordion-budget .showingBR {
    display: block;
    padding-left: 0;
}
.accordion-budget .dropright .dropdown-menu {
    top: 30px;
    left: 30%;
}
.accordion-budget .element-number {
    font-size: 1.28rem;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
